<template>
  <div id="app" class="">
    <notifications classes="notification" position="bottom right" />
    <router-view></router-view>
  </div>
</template>

<script>

// add jquery
global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $
global.isMobile = false

export default {
  name: 'app',
  mounted: function () {
    global.activeMarkerRotation

    $(window).resize( function(){
      if ($(window).width() < 781) {
        global.isMobile = true;
      } else {
        global.isMobile = false;
      }
    })

    $(window).resize()


  },
  created: function () {
    this.$store.commit('setAuthHeader')
    this.$store.commit('setInterceptor')
    this.$store.dispatch('checkAuthStatus')
  },
  metaInfo: {
    title: 'Arts en résidence – Réseau National',
    titleTemplate: '',
    meta: [
      {'http-equiv': 'Content-Type', 'content': 'text/html; charset=utf-8'},
      {'name': 'viewport', 'content': 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'},
      {'name': 'description', 'content': 'L’association Arts en résidence - Réseau national a pour objet de mettre en réseau et de fédérer les résidences d’artistes, de commissaires, de critiques d’art, de collectifs, ou de toute personne développant un projet s’inscrivant dans le champ des arts plastiques, en France.', 'vmid': 'description'},
      {'property': 'og:description', 'content': 'L’association Arts en résidence - Réseau national a pour objet de mettre en réseau et de fédérer les résidences d’artistes, de commissaires, de critiques d’art, de collectifs, ou de toute personne développant un projet s’inscrivant dans le champ des arts plastiques, en France.', 'vmid': 'description'},
      {'property': 'og:site_name', 'content': 'Arts en résidence – Réseau National', 'vmid': 'site_name'}
    ]
  }
}
</script>
<style lang="scss">
  @import "assets/scss/normalize.scss";
  @import "assets/scss/admin.scss";
  @import "/assets/scss/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue